import {
    FETCH_WISHLIST_REQUEST,
    FETCH_WISHLIST_SUCCESS,
    FETCH_WISHLIST_FAILURE
} from "../types";

const initialState = {
    wishlist: [],
    isLoading: false,
    error: null,
};

const wishlistReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WISHLIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_WISHLIST_SUCCESS:
            return {
                ...state,
                wishlist: action.payload,
                isLoading: false,
            };
        case FETCH_WISHLIST_FAILURE:
            return {
                ...state,
                wishlist: [],
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default wishlistReducer;
